import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

const { colors, common, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm + spacing.xs,
	},
	fieldLabel: {
		color: colors.text.dark,
		fontSize: typography.fontSizes.xs,
		fontWeight: typography.fontWeights.bold,
		marginBottom: spacing.xs,
	},
	fieldContainer: {
		display: 'flex',
		flexDirection: 'column',
	},
	input: {
		border: common.border,
		borderRadius: common.borderRadius,
		fontSize: typography.fontSizes.sm,
		paddingTop: spacing.sm,
		paddingBottom: spacing.sm,
		paddingLeft: spacing.sm + spacing.xs,
		paddingRight: spacing.sm + spacing.xs,
		width: '100%',
		boxSizing: 'border-box',
		':focus': {
			borderColor: colors.primary.main,
			outline: 'none',
		},
		':disabled': {
			backgroundColor: colors.background.dark,
			cursor: 'not-allowed',
		},
	},
	searchButton: {
		alignSelf: 'flex-start',
	},
});
